/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import Page from '../../Component/Pagination/Pagination'
import HeaderTable from '../../Component/BaseComponent/HeaderTable'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import cookie from 'react-cookies'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import $ from 'jquery'
import TMS from '../BaseComponent/TMS'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import HeaderGrid from '../Pagination/HeaderGrid'

class ReportTaskType extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      list: [],
      printInfo: [],
      editModal: false,
      deleteModal: false,
      sec: [],
      tasks: [],
      department: [],
      units: [],
      pageNumber: 1,
      countAll: 0,
      pageSize: 10,
      sortBy: 'departmentId_desc',
      getSort: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'دپارتمان',
          value: 'departmentId',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'بخش',
          value: 'sectionTitle',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'عنوان',
          value: 'title',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'واحد',
          value: 'unitTitle',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'زمان انجام از',
          value: ' timeMinuteMin',
          sorted: true,
          direction: null,
          sortable: true
        },

        {
          name: 'زمان انجام تا',
          value: 'timeMinuteMax',
          sorted: true,
          direction: null,
          sortable: true
        },
        {
          name: 'نیاز به تامیین کننده',
          value: ' needProvider',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نیاز به محصول',
          value: 'needProduct',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'مقدار پیش فرض تعداد',
          value: 'defaultCount',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'حداکثر فعالیت قابل ثبت',
          value: 'maxActivityCount',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'قابلیت ویرایش تعداد',
          value: 'editableCount',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'فعال',
          value: 'active',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'ویرایش',
          value: ' edit',
          sorted: false,
          direction: null,
          sortable: false
        },

        {
          name: 'حذف',
          value: 'delete',
          sorted: false,
          direction: null,
          sortable: false
        }
      ]
    }
  }

  getAll = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    http
      .get(`${TMS.TMS_MANAGE_BASE_TASK_REPORT}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          if (!exportStatus) {
            this.setState({
              list: response.data.object.result,
              countAll: response.data.object.countAll
            })
            $('.showBaseTable').fadeIn()
          } else {
            this.setState({
              excelReport: response.data.object.result,
              countAll: response.data.object.countAll,
              printInfo: response.data.object.result
            })
          }
        } else {
          this.setState({
            list: [],
            countAll: ''
          })
          $('.showBaseTable').fadeOut()
        }
      })
  }

  changeSec(e) {}

  componentDidMount() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', '')
    // http.get(`${TMS.TMS_MANAGE_BASE_SECTION_LIST}`,{
    //
    // }).then(response=>{
    //     if(response.data.error === null){
    //         this.setState({
    //             sec : response.data.object
    //         })
    //     }
    // })

    http.get(`${TMS.TMS_MANAGE_BASE_ORGANIZATION_LIST}`, {}).then((response) => {
      if (response.data.error === null) {
        this.setState({
          department: response.data.object
        })
      }
    })

    http.get(`${TMS.TMS_MANAGE_BASE_TASKUNIT_LIST}`, {}).then((response) => {
      if (response.data.error === null) {
        this.setState({
          units: response.data.object
        })
      }
    })

    this.getAll(false)

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })
  }

  activate = (enabled, id) => {
    if (enabled) {
      let data = {
        id: id
      }

      http
        .post(`${TMS.TMS_MANAGE_BASE_TASK_DISABLE}`, data, {})
        .then((response) => {
          if (response.data.error === null) {
            this.getAll()
          } else {
            // message.error(response.data.description)
          }
        })
        .catch((error) => {
          // alert(JSON.stringify(error))
        })
    } else {
      let data = {
        id: id
      }

      http
        .post(`${TMS.TMS_MANAGE_BASE_TASK_ENABLE}`, data, {})
        .then((response) => {
          // alert(JSON.stringify(response.data))
          if (response.data.error === null) {
            this.getAll()
          } else {
            // message.error(response.data.description)
          }
        })
        .catch((error) => {
          // alert(JSON.stringify(error))
        })
    }
  }

  edit = (
    id,
    title,
    sectionId,
    timeMinuteMin,
    timeMinuteMax,
    needProvider,
    needProduct,
    departmentId,
    editableCount,
    defaultCount,
    maxActivityCount,
    unitId
  ) => {
    http.get(`${TMS.TMS_MANAGE_BASE_SECTION_LIST}?departmentId=${departmentId}`, {}).then((response) => {
      if (response.data.error === null) {
        this.setState({
          sec: response.data.object
        })
      } else {
        this.setState({
          sec: []
        })
      }
    })

    this.setState({
      id,
      title,
      sectionId,
      timeMinuteMin,
      timeMinuteMax,
      needProvider,
      needProduct,
      orgId: departmentId,
      editableCount,
      unitId,
      defaultCount,
      maxActivityCount,
      editModal: !this.state.editModal
    })
  }
  editToggle = () => {
    this.setState({
      id: '',
      title: '',
      sectionId: '',
      timeMinuteMin: '',
      timeMinuteMax: '',
      needProvider: '',
      needProduct: '',
      editModal: !this.state.editModal,
      orgId: '',
      maxActivityCount: ''
    })
  }
  editCancel = () => {
    this.editToggle()
  }

  editOk = () => {
    var title = document.getElementById('titleM').value
    var sectionId = document.getElementById('sectionIdM').value
    var timeMinuteMin = document.getElementById('timeMinuteMinM').value
    var timeMinuteMax = document.getElementById('timeMinuteMaxM').value
    var needProvider = document.getElementById('needProviderM').value
    var needProduct = document.getElementById('needProductM').value
    let editableCount = document.getElementById('editableCount').value
    let defaultCount = document.getElementById('defaultCount').value
    let maxActivityCount = document.getElementById('maxActivityCount').value
    let unitId = document.getElementById('unitId').value
    let {id} = this.state
    var formError = false
    if (
      maxActivityCount === '' ||
      unitId === '' ||
      editableCount === '' ||
      defaultCount === '' ||
      needProvider === '' ||
      needProduct === '' ||
      title === '' ||
      sectionId === '' ||
      timeMinuteMax === '' ||
      timeMinuteMin === ''
    ) {
      formError = true
      message.error('همه فیلد ها وارد شود')
    } else if (needProvider == 0 && needProduct == 1) {
      formError = true
      message.error('نیاز به انتخاب تامین کننده اجباری است')
    } else if (Number(timeMinuteMin) > Number(timeMinuteMax)) {
      formError = true
      message.error('زمان ابتدا نباید بیشتر از زمان انتها باشد')
    }

    if (!formError) {
      let data = {
        id,
        title,
        sectionId,
        timeMinuteMin,
        timeMinuteMax,
        needProduct,
        needProvider,
        unitId,
        editableCount,
        defaultCount,
        maxActivityCount
      }
      http.post(`${TMS.TMS_MANAGE_BASE_TASK_UPDATE}`, data, {}).then((response) => {
        if (response.data.error === null) {
          message.success('نوع فعالیت ویرایش شد')
          this.getAll()
          this.editToggle()
        } else {
          // message.error(response.data.description)
        }
      })
    }
  }

  delete = (id, title) => {
    this.setState({
      id,
      title,
      deleteModal: !this.state.deleteModal
    })
  }
  toggleCancelDelete = () => {
    this.setState({
      id: '',
      title: '',
      deleteModal: !this.state.deleteModal
    })
  }
  deleteCancel = () => {
    this.toggleCancelDelete()
  }
  deleteOk = () => {
    let {id} = this.state
    let data = {
      id
    }
    http.post(`${TMS.TMS_MANAGE_BASE_TASK_DELETE}`, data, {}).then((response) => {
      if (response.data.error === null) {
        message.success('نوع فعالیت با موفقیت حذف شد')
        this.getAll()
        this.toggleCancelDelete()
      } else {
        this.setState({
          deleteModal: false
        })
      }
    })
  }

  changeDropDown(data) {
    this.setState({
      list: data,
      lengthProducts: this.state.countAll
    })
  }

  onResultFetched(data) {
    this.setState({
      list: data
    })
  }

  changeField(e) {
    let target = e.target
    let value = target.value
    let name = target.name
    this.setState({
      [name]: value
    })
  }

  exportExcel = () => {
    this.getAll(true)

    // alert(JSON.stringify(response.data))

    let {excelReport} = this.state
    for (let i = 0; i < excelReport.length; i++) {
      if (excelReport[i]['enabled']) {
        excelReport[i]['enabled'] = 'فعال'
      } else {
        excelReport[i]['enabled'] = 'غیر فعال'
      }
    }

    this._export.save(this.state.excelReport)
  }

  getPrintInfo = () => {
    this.getAll(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getAll(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getAll(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getAll(false)
    }
  }
  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }
  createFilter = (exportStatus) => {
    let filter = {}
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    let title = document.getElementById('title').value.trim()
    let departmentId = document.getElementById('departmentId').value.trim()
    let sectionId = document.getElementById('sectionId').value.trim()
    let needProvider = document.getElementById('needProvider').value.trim()
    let needProduct = document.getElementById('needProduct').value.trim()
    let timeMinuteMin = document.getElementById('timeMinuteMin').value.trim()
    let timeMinuteMax = document.getElementById('timeMinuteMax').value.trim()
    let maxActivityCountMax = document.getElementById('maxActivityCountMax').value.trim()
    let maxActivityCountMin = document.getElementById('maxActivityCountMin').value.trim()

    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }
    if (title !== '') {
      filter.title = title
    }
    if (departmentId !== '') {
      filter.departmentId = departmentId
    }
    if (sectionId !== '') {
      filter.sectionId = sectionId
    }
    if (maxActivityCountMin !== '') {
      filter.maxActivityCountMin = maxActivityCountMin
    }
    if (maxActivityCountMax !== '') {
      filter.maxActivityCountMax = maxActivityCountMax
    }
    if (needProvider !== '') {
      filter.needProvider = needProvider
    }
    if (needProduct !== '') {
      filter.needProduct = needProduct
    }
    if (timeMinuteMax !== '') {
      filter.timeMinuteMin = timeMinuteMin
    }
    if (timeMinuteMax !== '') {
      filter.timeMinuteMax = timeMinuteMax
    }

    return filter
  }

  filter() {
    // sessionStorage.setItem("params", `name=${name}&bank=${bank}`);
    this.setState(
      {
        pageNumber: 1
      },
      () => {
        this.getAll(false)
      }
    )
  }

  validateMin = (evt) => {
    if ((evt.which != 8 && evt.which != 0 && evt.which < 48) || evt.which > 57) {
      evt.preventDefault()
    }
  }

  changeOrg(e) {
    let name = e.target.name
    let value = e.target.value
    if (value === '') {
      this.setState({
        sec: []
      })
    } else {
      this.setState({
        departmentId: value
      })
      http.get(`${TMS.TMS_MANAGE_BASE_SECTION_LIST}?departmentId=${value}`, {}).then((response) => {
        if (response.data.error === null) {
          this.setState({
            sec: response.data.object
          })
        } else {
          this.setState({
            sec: []
          })
        }
      })
    }
  }

  convertState = (state) => {
    if (state === 1) {
      return 'اجباری'
    } else if (state === 0) {
      return 'اختیاری'
    } else if (state === -1) {
      return 'عدم انتخاب'
    }
  }

  changeNeedProvider = (e) => {
    let value = e.target.value
    this.setState({
      needProvider: value
    })
    if (value == -1) {
      this.setState({
        needProduct: -1
      })
    }
  }
  changeNeedProduct = (e) => {
    let value = e.target.value
    this.setState({
      needProduct: value
    })
  }
  render() {
    let {pageNumber, pageSize, countAll} = this.state
    let urlParams = sessionStorage.getItem('params')
    let printCol = [
      'ردیف',
      'دپارتمان',
      'بخش',
      'عنوان',
      'زمان انجام از',
      'زمان انجام تا',
      'نیاز به تامین کننده',
      'نیاز به محصول',
      'مقدار پیش فرض تعداد',
      'حداکثر فعالیت تکراری قابل ثبت',
      'قابلیت ویرایش تعداد'
    ]
    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="اطلاعات پایه نوع فعالیت"
              headerColSpan={12}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={6}
              rightColSpan={5}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((temp, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{temp.departmentTitle}</td>
                  <td>{temp.sectionTitle}</td>
                  <td>{temp.title}</td>
                  <td>{temp.timeMinuteMin + ' دقیقه '}</td>
                  <td>{temp.timeMinuteMax + ' دقیقه '}</td>
                  <td>{this.convertState(temp.needProvider)}</td>
                  <td>{this.convertState(temp.needProduct)}</td>
                  <td>{temp.defaultCount}</td>
                  <td>{temp.maxActivityCount}</td>

                  <td>
                    {temp.editableCount ? (
                      <img width={20} src={require('../../image/confirm.svg')} title="دارد" />
                    ) : (
                      <img width={20} title="ندارد" src={require('../../image/ignor.svg')} />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="اطلاعات پایه نوع فعالیت.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'departmentTitle'}
                field={'departmentTitle'}
                title={'دپارتمان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'sectionTitle'}
                field={'sectionTitle'}
                title={'بخش'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'title'}
                field={'title'}
                title={'عنوان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'enabled'}
                field={'enabled'}
                title={'وضعیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>مدیریت فعالیت ها</li>
            <li>نوع فعالیت ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={'/base/create/tms/taskType'} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                {/*<button className={'printButton'} onClick={this.exportExcel}>*/}
                {/*    <i className='fas fa-file-excel'></i>*/}
                {/*</button>*/}
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="filterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label htmlFor="ماهیت">دپارتمان</label>
                  <select
                    className="form-control"
                    onChange={this.changeOrg.bind(this)}
                    name="departmentId"
                    id="departmentId"
                  >
                    <option value="">------</option>
                    {this.state.department.map((item, index) => (
                      <option value={item.id} key={index}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    بخش
                  </label>
                  <select
                    className="custom-select"
                    onChange={this.changeSec.bind(this)}
                    name="sectionId"
                    id="sectionId"
                  >
                    <option value="">------</option>
                    {this.state.sec.map((item, index) => (
                      <option value={item.id} key={index}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="عنوان">
                    عنوان
                  </label>
                  <input type="text" id="title" className="form-control" />
                </div>

                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    {' '}
                    نیاز به تامین کننده
                  </label>
                  <select className="custom-select" name="needProvider" id="needProvider">
                    <option value="">------</option>
                    <option value={0}>اختیاری</option>
                    <option value={1}>اجباری</option>
                    <option value={-1}>عدم انتخاب</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    {' '}
                    نیاز به محصول
                  </label>
                  <select className="custom-select" name="needProduct" id="needProduct">
                    <option value="">------</option>
                    <option value={0}>اختیاری</option>
                    <option value={1}>اجباری</option>
                    <option value={-1}>عدم انتخاب</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    زمان از
                  </label>
                  <input
                    type="number"
                    min={1}
                    onKeyPress={this.validateMin.bind(this)}
                    id="timeMinuteMin"
                    className="form-control"
                  />
                </div>

                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    زمان تا
                  </label>
                  <input
                    type="number"
                    min={1}
                    onKeyPress={this.validateMin.bind(this)}
                    id="timeMinuteMax"
                    className="form-control"
                  />
                </div>

                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    حداکثر فعالیت تکراری قابل ثبت از{' '}
                  </label>
                  <input type="number" min={1} id="maxActivityCountMin" className="form-control" />
                </div>
                <div className="formComponent">
                  <label className="font-weight-bold" htmlFor="ماهیت">
                    حداکثر فعالیت تکراری قابل ثبت تا{' '}
                  </label>
                  <input type="number" min={1} id="maxActivityCountMax" className="form-control" />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />
                  {this.state.list.map((temp, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      <td>{temp.departmentTitle}</td>
                      <td>{temp.sectionTitle}</td>
                      <td>{temp.title}</td>
                      <td>{temp.unitTitle}</td>
                      <td>{temp.timeMinuteMin + ' دقیقه '}</td>
                      <td>{temp.timeMinuteMax + ' دقیقه '}</td>
                      <td>{this.convertState(temp.needProvider)}</td>
                      <td>{this.convertState(temp.needProduct)}</td>
                      <td>{temp.defaultCount}</td>
                      <td>{temp.maxActivityCount}</td>
                      <td>
                        {temp.editableCount ? (
                          <img src={require('../../image/confirm.svg')} title="دارد" />
                        ) : (
                          <img title="ندارد" src={require('../../image/ignor.svg')} />
                        )}
                      </td>

                      <td>
                        <button onClick={() => this.activate(temp.enabled, temp.id)}>
                          {temp.enabled ? (
                            <img src={require('../../image/on.svg')} alt="" />
                          ) : (
                            <img src={require('../../image/off.svg')} alt="" />
                          )}
                        </button>
                      </td>
                      <td>
                        <button
                          onClick={() =>
                            this.edit(
                              temp.id,
                              temp.title,
                              temp.sectionId,
                              temp.timeMinuteMin,
                              temp.timeMinuteMax,
                              temp.needProvider,
                              temp.needProduct,
                              temp.departmentId,
                              temp.editableCount,
                              temp.defaultCount,
                              temp.maxActivityCount,
                              temp.unitId
                            )
                          }
                        >
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </button>
                      </td>
                      <td>
                        <button onClick={() => this.delete(temp.id, temp.title)}>
                          <img src={require('../../image/trash.svg')} alt={'trash'} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.countAll}
                />
              </div>
            </div>
          </div>
        </div>

        <Modal isOpen={this.state.deleteModal} toggle={this.toggleCancelDelete} size="sm">
          <ModalHeader toggle={this.toggleCancelDelete}>حذف فعالیت</ModalHeader>
          <ModalBody>
            <p className="titleSm">آیا از حذف فعالیت {this.state.title} مطمئن هستید؟؟؟</p>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.deleteOk}>
              حذف
            </button>
            <button className="cancelBtnModal" onClick={this.deleteCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.editModal} toggle={this.editToggle} size="sm">
          <ModalHeader toggle={this.editToggle}>ویرایش فعالیت</ModalHeader>
          <ModalBody>
            <div className="modalForm">
              <div className="formComponent">
                <label>
                  {' '}
                  عنوان : <span className="requireFiled">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="title"
                  onChange={this.changeField.bind(this)}
                  defaultValue={this.state.title}
                  id="titleM"
                />
              </div>

              <div className="formComponent">
                <label htmlFor="ماهیت">
                  دپارتمان<span className="requireFiled">*</span>
                </label>
                <select
                  className="form-control"
                  onChange={this.changeOrg.bind(this)}
                  name="departmentId"
                  id="departmentId"
                >
                  <option value="">------</option>
                  {this.state.department.map((item, index) => (
                    <option value={item.id} selected={this.state.orgId === item.id ? true : false} key={index}>
                      {item.title}
                    </option>
                  ))}
                </select>
              </div>

              <div className="formComponent">
                <label>
                  بخش <span className="requireFiled">*</span>
                </label>
                <select className="form-control" id="sectionIdM">
                  <option value="">------</option>
                  {this.state.sec.map((item, index) => (
                    <option selected={this.state.sectionId === item.id} key={index} value={item.id}>
                      {item.title}
                    </option>
                  ))}
                </select>
              </div>

              <div className="formComponent">
                <label>
                  زمان انجام از (دقیقه) <span className="requireFiled">*</span>
                </label>
                <input
                  type="number"
                  defaultValue={this.state.timeMinuteMin}
                  id="timeMinuteMinM"
                  className="form-control"
                />
              </div>

              <div className="formComponent">
                <label>
                  زمان انجام تا (دقیقه) <span className="requireFiled">*</span>
                </label>
                <input
                  type="number"
                  defaultValue={this.state.timeMinuteMax}
                  id="timeMinuteMaxM"
                  className="form-control"
                />
              </div>

              <div className="formComponent">
                <label>
                  نیاز به انتخاب تامین کننده<span className="requireFiled">*</span>
                </label>
                <select onChange={this.changeNeedProvider} className="form-control" id="needProviderM">
                  <option value={0} selected={this.state.needProvider === 0 ? true : false}>
                    اختیاری
                  </option>
                  <option value={1} selected={this.state.needProvider === 1 ? true : false}>
                    اجباری
                  </option>
                  <option value={-1} selected={this.state.needProvider === -1 ? true : false}>
                    عدم انتخاب
                  </option>
                </select>
              </div>

              <div className="formComponent">
                <label>
                  نیاز به انتخاب محصول <span className="requireFiled">*</span>
                </label>
                <select onChange={this.changeNeedProduct} className="form-control" id="needProductM">
                  <option
                    value={0}
                    disabled={this.state.needProvider == -1 ? true : false}
                    selected={this.state.needProduct == 0 ? true : false}
                  >
                    اختیاری
                  </option>
                  <option
                    value={1}
                    disabled={this.state.needProvider == -1 ? true : false}
                    selected={this.state.needProduct == 1 ? true : false}
                  >
                    اجباری
                  </option>
                  <option value={-1} selected={this.state.needProduct == -1 ? true : false}>
                    عدم انتخاب
                  </option>
                </select>
              </div>

              <div className="formComponent">
                <label>
                  مقدار پیش فرض تعداد<span className="requireFiled">*</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  defaultValue={this.state.defaultCount}
                  id="defaultCount"
                />
              </div>

              <div className="formComponent">
                <label>
                  حداکثر فعالیت تکراری قابل ثبت<span className="requireFiled">*</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  defaultValue={this.state.maxActivityCount}
                  id="maxActivityCount"
                />
              </div>

              <div className="formComponent">
                <label>
                  قابلیت ویرایش تعداد<span className="requireFiled">*</span>
                </label>
                <select className="form-control" id="editableCount">
                  {/*<option value=''>------</option>*/}
                  <option value={0} selected={this.state.editableCount ? true : false}>
                    خیر
                  </option>
                  <option value={1} selected={this.state.editableCount ? true : false}>
                    بله
                  </option>
                </select>
              </div>
              <div className="formComponent">
                <label>
                  واحد<span className="requireFiled">*</span>
                </label>
                <select className="form-control" id="unitId">
                  <option value="">------</option>
                  {this.state.units.map((item, index) => (
                    <option value={item.id} selected={this.state.unitId === item.id} key={index}>
                      {item.title}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.editOk}>
              ویرایش{' '}
            </button>
            <button className="cancelBtnModal" onClick={this.editCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
export default ReportTaskType
